import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

/* NgRx */
import { StoreModule } from '@ngrx/store';
import { reducer } from './state/customers.reducer';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EffectsModule } from '@ngrx/effects';
import { CustomersEffects } from './state/customers.effects';

import { CustomersShellComponent } from './containers/customers-shell/customers-shell.component';
import { CustomersListComponent } from './components/customers-list/customers-list.component';
import { CustomersEditShellComponent } from './containers/customers-edit-shell/customers-edit-shell.component';
import { CustomersEditComponent } from './components/customers-edit/customers-edit.component';


@NgModule({
  declarations: [
    CustomersShellComponent,
    CustomersEditShellComponent,
    CustomersListComponent,
    CustomersEditComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    StoreModule.forFeature('customerss', reducer),
    EffectsModule.forFeature([CustomersEffects])
  ],
  exports: [
    CustomersListComponent,
    CustomersEditComponent,
    CommonModule,
    FormsModule,
    ReactiveFormsModule
  ]
})
export class CustomersModule {
  constructor(
  ) {}
}
